import React from "react";
import { Card, CardHeader, CardContent, Grid, Typography, Link, Chip, Button, Box } from "@mui/material"
import { DriveFileMove } from "@mui/icons-material";
import styled from "@emotion/styled"
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const InfoCard = styled(Card)(({ theme }) => ({
    gridColumn: 'span 3',
    [theme.breakpoints.up('sm')]: {
        gridColumn: 'span 1',
    }
}));

const CardTitleText = styled(Typography)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.h5.fontSize,
}));

const ContentGrid = styled(Grid)(({ theme }) => ({
    paddingBottom: theme.spacing(1),
}));

const StyledLink = styled(Link)(({ theme }) => ({
    cursor: 'pointer',
    textDecoration: 'none',
    '&:hover': {
        textDecoration: 'underline',
    },
}));

const HeaderActions = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
}));

const ProjectAccountInfo = ({ project, accountSlug, canMove = false, onMove }) => {
    const navigate = useNavigate();
    const account = useSelector(state => state.project.currentProject.account);
    const accountInactive = account?.active === false;
    const clientInactive = account?.client?.active === false;
    const inactiveLabel = clientInactive && !accountInactive ? 'Client Inactive' : 'Inactive';
    const showHeaderActions = accountInactive || clientInactive || canMove;

    return (
        <InfoCard>
            <CardHeader
                title={<CardTitleText>Account Information</CardTitleText>}
                action={showHeaderActions ? (
                    <HeaderActions>
                        {(accountInactive || clientInactive) && <Chip color="warning" variant="outlined" size="small" label={inactiveLabel} />}
                        {canMove && (
                            <Button size="small" startIcon={<DriveFileMove />} onClick={onMove} aria-label="Move project to another account">
                                Move
                            </Button>
                        )}
                    </HeaderActions>
                ) : null}
            />
            <CardContent>
                <Grid container>
                    <ContentGrid>
                        <Typography varian="body2">Client Name</Typography>
                        <StyledLink onClick={() => navigate(`/client/${account.client?.slug}`)} variant="subtitle2">{account.client?.name}</StyledLink>
                    </ContentGrid>
                    <ContentGrid item xs={12}>
                        <Typography variant="body2">Account Name</Typography>
                        <StyledLink onClick={() => navigate(`/account/${account?.slug}`)} variant="subtitle2">{account?.name}</StyledLink>
                    </ContentGrid>
                    <ContentGrid item xs={12}>
                        <Typography variant="body2">Account Manager</Typography>
                        <Typography variant="subtitle2">{account.accountManager?.fullName || 'Unassigned'}</Typography>
                    </ContentGrid>
                </Grid>
            </CardContent>
        </InfoCard>
    );
};

export default ProjectAccountInfo;